<template>
  <div>
    <el-tabs v-model="currentType" @tab-click="tabSwitch">
      <el-tab-pane label="个人客户" name="person">
        <base-list-management
          :ref="CUSTOMER_CONFIG[CUSTOMER_TYPE.person].ref"
          :configData="personConfig"
          >
          <PublicExport
            slot="custom-export"
            v-if="judgePermission('driver_customer_list_export')"
            exportTitle="个人客户导出"
            exportTemplate="Customer"
            :getSearchData="searchParams.bind(this, CUSTOMER_TYPE.person)"
            templateCode="vehicle-individual-customer"
            :getSearchCondition="getSearchCondition.bind(this, CUSTOMER_TYPE.person, personConfig)"
          />
          <div slot="custom-operate">
            <el-button
              type="primary"
              v-if="judgePermission('driver_customer_list_create')"
              @click="addCustomer"
              >
              新增客户
            </el-button>

            <el-button
              type="primary"
              v-if="judgePermission('driver_customer_list_export_picture')"
              @click="openImportDialog(IMPORT_TYPE.IMG)"
              >
              {{ CUSTOMER_CONFIG.person.label }}证照图片导入
            </el-button>

            <el-button
              type="primary"
              v-if="judgePermission('driver_customer_list_import')"
              @click="batchImportClick"
              >
              客户信息导入
            </el-button>
          </div>
        </base-list-management>
      </el-tab-pane>
      <el-tab-pane label="企业客户" name="company">
        <base-list-management
          :ref="CUSTOMER_CONFIG[CUSTOMER_TYPE.company].ref"
          :configData="companyConfig"
          >
          <PublicExport
            slot="custom-export"
            v-if="judgePermission('driver_customer_list_export')"
            exportTitle="企业客户导出"
            exportTemplate="Customer"
            :getSearchData="searchParams.bind(this, CUSTOMER_TYPE.company)"
            templateCode="vehicle-enterprise-customer"
            :getSearchCondition="getSearchCondition.bind(this, CUSTOMER_TYPE.company, companyConfig)"
          />
          <div slot="custom-operate">
            <el-button
              type="primary"
              v-if="judgePermission('driver_customer_list_create_company')"
              @click="addCustomer"
              >
              新增客户
            </el-button>

            <el-button
              type="primary"
              v-if="judgePermission('driver_customer_list_export_picture')"
              @click="openImportDialog(IMPORT_TYPE.IMG)"
              >
              {{ CUSTOMER_CONFIG.company.label }}证照图片导入
            </el-button>

            <el-button
              type="primary"
              v-if="judgePermission('driver_customer_list_import')"
              @click="batchImportClick()"
              >
              客户信息导入
            </el-button>
          </div>
        </base-list-management>
      </el-tab-pane>
    </el-tabs>
    <!-- 批量导入图片组件 -->
    <BatchImport
      :importType="importType"
      :importVisible.sync="importDialogVisible"
      :customerType="currentType"
    />
    <!-- 批量导入客户组件 -->
    <!-- 批量导入客户 -->
    <dialog-wrap-upgrade ref="bathImport" :configOptions="batchImportConfig">
      <template #importIndividualExcel>
        <el-upload
          class="upload-demo"
          action=""
          :limit="1"
          :http-request="(data) => uploadRequest(data, 1)"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          v-if="judgePermission('driver_customer_list_import')"
          >
          <el-button type="primary" size="small" :loading="personUploadLoading">导入个人Excel</el-button>
        </el-upload>
      </template>
      <template #importCompanyExcel>
        <el-upload
          class="upload-demo"
          action=""
          :limit="1"
          :http-request="(data) => uploadRequest(data, 2)"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          v-if="judgePermission('driver_customer_list_import')"
          >
          <el-button type="primary" size="small" :loading="companyUploadLoading">导入企业Excel</el-button>
        </el-upload>
      </template>
    </dialog-wrap-upgrade>
    <!-- 导入失败-弹窗-开始 -->
    <dialogWrap
      v-model="uploadDialogShow"
      title="导入失败提示"
      :width="'750px'"
      class="spring-frame"
      :before-close="beforeUploadClose"
      >
      <p
        v-for="(item, index) in uploadTableData"
        :key="index"
        style="margin-bottom: 8px"
        >
        {{ item }}
      </p>
    </dialogWrap>
    <!-- 导入失败-弹窗-结束 -->
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { searchByCustomerNameSensitive, customerExcel } from '@/api/domain/customers'
import { getAllEmployeeList } from '@/api/carManage'
import { CUSTOMER_TYPE, CUSTOMER_CONFIG, configFn, IMPORT_TYPE } from './config'
import BatchImport from './BatchImport.vue'
import { mapState } from 'vuex'
import { cloneDeep, omit } from 'lodash'
import {
  enterpriseCustomerTemplate,
  individualCustomerTemplate,
} from '@/config'
import axios from 'axios'
import { getHead } from '@/utils'
import { generateExportCondition } from '@/utils/exportUtils.js'

export default {
  components: { BatchImport },
  data() {
    // type：person-个人，company-企业
    const { type } = this.$route.query
    // 如果没有类型，默认为个人
    const customerType = type || CUSTOMER_TYPE.person
    const configData = configFn.call(this)

    return {
      CUSTOMER_TYPE,
      CUSTOMER_CONFIG,
      personUploadLoading: false,
      companyUploadLoading: false,
      IMPORT_TYPE,
      currentType: customerType,
      personConfig: cloneDeep(configData.person.configData),
      companyConfig: cloneDeep(configData.company.configData),
      importType: IMPORT_TYPE.IMG,
      // 导入弹窗展示开关
      importDialogVisible: false,
      fileList: [],
      uploadTableData: [],
      uploadDialogShow: false,
      batchImportConfig: {
        attrs: {
          title: '批量导入客户',
          width: '840px',
        },
        isDefaultMode: false,
        contentConfig: {
          title:
            '这个功能的前提是，您已经制作了一张目标表单希望直接将Excel转移到系统，请单击 下载Excel标准模板。',
          describes: [
            '导入前准备：',
            '1.请使用标准模板，确认未进行过任何更改，若无意中修改了模板的原有内容，建议重新下载模板；',
            '2.确保Excel中标题行的名称和表单中与之对应的字段标题一致，且表单中字段名称不能相同；',
            '3.确保Excel中数据没有任何颜色样式，否则将与导入功能的错误提示混淆；',
            '4.确保excel中数据格式正确。比如账号为数字格式，请不要输入字母/汉字；',
            '5.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
            '6.Excel多余的列无法导入，请删除Excel中不需要导入的列；',
          ],
        },
        footerList: [
          { slotName: 'importIndividualExcel' },
          { slotName: 'importCompanyExcel' },
          {
            text: '个人客户导入模板',
            options: {
              type: 'primary',
            },
            isShowBtn: () => {
              this.judgePermission('driver_customer_list_import')
            },
            click: () => {
              this.templateClick(individualCustomerTemplate)
            },
          },
          {
            text: '企业客户导入模板',
            options: {
              type: 'primary',
            },
            isShowBtn: () => {
              this.judgePermission('driver_customer_list_import')
            },
            click: () => {
              this.templateClick(enterpriseCustomerTemplate)
            },
          },
        ],
      },
      customerConditionList: [],
      driverManagerConditionList: [],
      carManagerConditionList: [],
    }
  },
  computed: {
    ...mapState({
      tags: (state) => state.customer.tags, // 客户标签
    }),
  },
  mounted() {
    const tableRef = this.$refs[CUSTOMER_CONFIG[this.currentType].ref]
    if (this.tags.length === 0) {
      this.$store.dispatch('getTags').then((data) => {
        tableRef.setItemData({ elConfigKey: 'list', key: 'tagId', data })
      })
    } else {
      tableRef.setItemData({
        elConfigKey: 'list',
        key: 'tagId',
        data: this.tags,
      })
    }
    // 加载所有司管和车管
    this.loadAllEmployees()
  },
  methods: {
    // 切换Tab
    tabSwitch(tab) {
      this.$nextTick(() => {
        const { name: tabName } = tab
        // 将筛选项折叠
        const baseListEl = this.$refs[CUSTOMER_CONFIG[tabName].ref]
        baseListEl.getRefs({}).$refs.blmSearch.showAll = false
        baseListEl.reset()
        baseListEl.setItemData({
          elConfigKey: 'list',
          key: 'tagId',
          data: this.tags,
        })
        // 加载所有司管和车管
        this.loadAllEmployees()
      })
    },
    // 打开导入弹窗
    openImportDialog(type) {
      this.importType = type
      this.importDialogVisible = true
    },
    // 搜索客户名称 ./config.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    searchCustomers(type, name) {
      if (name.length === 0) return
      // 后端接口会返回所有数据，所以暂时前端添加pageSize限制
      searchByCustomerNameSensitive({
        customerType: CUSTOMER_CONFIG[type].value,
        customerName: name,
      }).then((res) => {
        const { code, data = [] } = res
        if (code === 1) {
          this.$refs[CUSTOMER_CONFIG[this.currentType].ref].setItemData({
            elConfigKey: 'list',
            key: 'id',
            data,
          })
        }
      })
    },
    // 加载所有员工（司管和车管）
    loadAllEmployees() {
      getAllEmployeeList({ includeDisabled: 'YES' }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const tableRef = this.$refs[CUSTOMER_CONFIG[this.currentType].ref]
          // 为司管和车管都设置相同的员工列表
          tableRef.setItemData({
            elConfigKey: 'list',
            key: 'driverManagerId',
            data,
          })
          tableRef.setItemData({
            elConfigKey: 'list',
            key: 'vehicleManagerId',
            data,
          })
        }
      })
    },
    // 跳转客户详情 ./config.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    linkToDetail(row) {
      this.$router.push({
        path: '/driver/customerManage/detail',
        query: {
          id: row.id,
          customerType: row.customerType,
        },
      })
    },
    // 编辑客户 ./config.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    editHandle(row) {
      const { customerType, recordId } = row
      // customerType 1-个人 2-企业
      const type =
        customerType === 1 ? CUSTOMER_TYPE.person : CUSTOMER_TYPE.company
      this.$router.push({
        path: `/driver/customerManage/edit/${type}`,
        query: {
          customerType,
          id: recordId,
        },
      })
    },
    // 新增客户
    addCustomer() {
      this.$router.push(`/driver/customerManage/add/${this.currentType}`)
    },
    search() {
      this.$refs[CUSTOMER_CONFIG[this.currentType]?.ref]?.searchForm()
    },
    /* 自定义上传,type（客户类型）: 1-个人 2-企业 */
    uploadRequest({ file }, type) {
      const para =
        Number(type) === 1 ? 'assert_person_file' : 'assert_company_file'
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'assert')
      formData.append('code', para)

      if (Number(type) === 1) {
        this.personUploadLoading = true
      }
      if (Number(type) === 2) {
        this.companyUploadLoading = true
      }

      axios({
        url: '/admin/v1/vehicle/fs/standard/upload',
        method: 'POST',
        data: formData,
        headers: {
          ...this.headers,
          ...getHead(this.$store),
        },
        onUploadProgress: ({ loaded, total }) => {
          this.isProgress = true
          this.disabled = true
          this.uploadPercent = parseInt(loaded / total)
        },
      }).then(({ data: { code, data, msg } }) => {
        if (code === 1) {
          try {
            customerExcel({
              fileAddress: data,
              customerType: type,
            })
              .then((res) => {
                const { code: c, data: d } = res
                if (c === 1) {
                  this.$message({ message: '导入成功', type: 'success' })
                  this.search()
                } else if (c === 23023) {
                  if (d && d.length > 0) {
                    this.uploadTableData = d || []
                    this.uploadDialogShow = true
                  }
                }
              }).finally(() => {
                if (Number(type) === 1) {
                  this.personUploadLoading = false
                }
                if (Number(type) === 2) {
                  this.companyUploadLoading = false
                }
              })
            this.fileList = []
          } catch (error) {
            this.fileList = []
          }
        } else {
          this.fileList = []
          this.$message.error(msg)
        }
      }).catch(() => {
        if (Number(type) === 1) {
          this.personUploadLoading = false
        }
        if (Number(type) === 2) {
          this.companyUploadLoading = false
        }
      })
    },
    // 批量信息导入弹窗
    batchImportClick() {
      this.$refs.bathImport.showDialog()
    },
    // 导入模版下载
    templateClick(link) {
      window.location.href = link
    },
    beforeUploadClose() {
      this.uploadTableData = []
      this.uploadDialogShow = false
    },
    searchParams(type) {
      return this.$refs[CUSTOMER_CONFIG[type].ref]?.getParams()
    },
    getSearchCondition(type, config) {
      const params = this.$refs[CUSTOMER_CONFIG[type].ref]?.getParams()
      // input和日期没有值时不展示，其他没有值时展示全部
      const condition = config.formData.list.map((item) => {
        const {
          el,
          itemConfig: { label, prop: key },
        } = item
        if (key === 'id') {
          item.elConfig.options.list = this.customerConditionList
        }
        if (key === 'managerId') {
          item.elConfig.options.list = this.driverManagerConditionList
        }
        if (key === 'vehicleManagerId') {
          item.elConfig.options.list = this.carManagerConditionList
        }
        const val = params[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      condition.push({
        label: '客户类型',
        matchValue: CUSTOMER_CONFIG[type].label,
      })
      return condition
    },
  },
}
</script>
<style lang="scss" scoped>
.link {
  color: #276bec;
  cursor: pointer;
  &:hover {
    color: #5087ed;
  }
}
</style>
